import * as JsonPatch from "fast-json-patch";
import {HTTP} from "@/http";
import {Quiz} from "@/page/quiz/typeQuiz";
export async function save(
  path: string,
  str: string,
  obj: object,
  additionally = {}
): Promise<Quiz | void> {
  let _id = "";
  if ("_id" in obj) {
    _id = obj._id as string;
  }

  if (_id == "" || str == "") {
    return;
  }

  let oldObj = JSON.parse(str);

  let compare = JsonPatch.compare(oldObj, obj);

  if (compare.length == 0) {
    return;
  }

  let send = {compare, ...additionally};
  return await HTTP.post(path, send);
}
